import {
  PartnerBranding,
  RALDRealtyConfig,
  PartnerProperty,
} from "@/types/partner";

export const RALD_REALTY_CONFIG: RALDRealtyConfig = {
  partnerId: "rald-realty",
  name: "RALD REALTY",
  primaryColor: "#1a4d2e",
  secondaryColor: "#2d6a4f",
  textColor: "#ffffff",
  accentColor: "#52b788",
  logoUrl: "/assets/partners/rald-realty-logo.svg",
  featuredPlacement: true,
  customBadges: ["Premium Partner", "Featured"],
  enhancedDisplay: true,
};

export const applyPartnerBranding = (
  partnerId: string,
): PartnerBranding | RALDRealtyConfig | null => {
  if (partnerId === "rald-realty") {
    return RALD_REALTY_CONFIG;
  }
  return null;
};

export const generatePartnerBadges = (property: PartnerProperty): string[] => {
  const badges: string[] = [];

  if (property.featured) {
    badges.push("Featured");
  }

  if (property.partner) {
    const config = property.partner as RALDRealtyConfig;
    if (config.customBadges) {
      badges.push(...config.customBadges);
    }
  }

  if (property.badges) {
    badges.push(...property.badges);
  }

  return [...new Set(badges)];
};

export const enhancePropertyData = (
  property: Partial<PartnerProperty>,
  partnerId: string,
): PartnerProperty => {
  const branding = applyPartnerBranding(partnerId);

  return {
    ...property,
    id: property.id || "",
    partnerId,
    partner: branding || undefined,
    badges: generatePartnerBadges(property as PartnerProperty),
    featured: property.featured || false,
    price: property.price || 0,
    total_package: property.total_package || property.price || 0,
  } as PartnerProperty;
};

export const getPartnerCustomColors = (
  partnerId: string,
): { primary: string; secondary: string; text: string; accent: string } => {
  const branding = applyPartnerBranding(partnerId);

  if (branding) {
    return {
      primary: branding.primaryColor,
      secondary: branding.secondaryColor,
      text: branding.textColor,
      accent: branding.accentColor || branding.primaryColor,
    };
  }

  return {
    primary: "#0066cc",
    secondary: "#004999",
    text: "#ffffff",
    accent: "#3399ff",
  };
};

export const formatPartnerInfo = (
  partner: PartnerBranding | RALDRealtyConfig,
): {
  displayName: string;
  logo: string;
  colors: { primary: string; secondary: string; text: string; accent: string };
} => {
  return {
    displayName: partner.name,
    logo: partner.logoUrl,
    colors: {
      primary: partner.primaryColor,
      secondary: partner.secondaryColor,
      text: partner.textColor,
      accent: partner.accentColor || partner.primaryColor,
    },
  };
};
